// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"b8ea8fb7","481":"9a161d43","534":"2ec4bf72"}[chunkId] + ".css";
};